module.exports = __webpack_public_path__ + "static/media/ProximaNova-ExtrabldIt.6ba3d757.eot";